import { toast } from "react-toastify";
import axios from "axios";

export const loginByAuth = async (email, password) => {
  const bodyFormData = new FormData();
  bodyFormData.append("username", email);
  bodyFormData.append("password", password);

  const config = {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  };

  try {
    const url = `${process.env.REACT_APP_API_URL}/login`;
    const res = await axios.post(url, bodyFormData, config);

    return res.data;
  } catch (err) {
    throw err;
  }
};
export const forgotPasswordByEmailVerification = async (email) => {
  const data = { email };

  const config = {
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/forget-password`,
      data,
      config
    );
    if (response?.data?.message) {
      toast.success(response.data.message);
    }

    return response.data;

  } catch (err) {
    const errorMsg = err?.response?.data?.error;
    if (errorMsg === "User not found") {
      toast.error(
        "Your email is not recognized in the database. Please contact ACTION-CARDS support at contact@action-cards.com"
      );
    } else {
      toast.error(errorMsg || "Something went wrong. Please try again.");
    }
    return null;
  }
};

export const resetPassword = async (password, token) => {
  const data = {
    password
  }

  const config = {
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/reset-password/${token}`, data, config)
    toast.success(response.data.message);
    return response.data;
  } catch (err) {
    toast.error(err.response.data.error);
    throw err;

  }
};

